import { render } from "./NavLink.vue?vue&type=template&id=1a39f122&scoped=true"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"

import "./NavLink.vue?vue&type=style&index=0&id=1a39f122&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1a39f122"

export default script